/* global BigInt */
import contract from './noodleSetEvidenceFields.json';
export const NOODLE_MANIFEST_KEY = contract.fact_key;
export {contract as noodleSetEvidenceContract};
const own=(o,k)=>o && Object.prototype.hasOwnProperty.call(o,k);
const keys=(n,allowed)=>n && typeof n==='object' && !Array.isArray(n) && Object.keys(n).every(k=>allowed.includes(k));
const text=(n,max,required=false)=>typeof n==='string' && n.length<=max && (!required || n.trim().length>0);
const scaled=n=>{const [w,f='']=n.split('.');return BigInt(w)*1000000n+BigInt(f.padEnd(6,'0'));};
const decimal=(n,spec)=>{
 if(!text(n,19,true)||!/^(?:0|[1-9]\d{0,11})(?:\.\d{1,6})?$/.test(n))return null;
 const [w,f='']=n.split('.'), fraction=f.replace(/0+$/,'');
 if(spec.integer&&fraction)return null;
 if(spec.maximum!==undefined&&scaled(n)>scaled(spec.maximum))return null;
 return w+(fraction?'.'+fraction:'');
};
export function validateNoodleManifest(manifest){
 const invalid=reason=>({valid:false,status:'invalid',reason,final:false});
 try{if(JSON.stringify(manifest)?.length>(contract.max_serialized_chars||262144))return invalid('명세가 저장 한도를 초과했습니다. 긴 인용문을 필요한 부분으로 줄여 주세요.');}
 catch{return invalid('명세 형식을 확인해 주세요.');}
 if(!keys(manifest,['schema','inventory_complete','confirmed','paused','presentation','components'])||manifest.schema!==1)return invalid('명세 형식을 확인해 주세요.');
 if(!['inventory_complete','confirmed','paused'].every(k=>typeof manifest[k]==='boolean'))return invalid('확인 상태를 확인해 주세요.');
 if(!Array.isArray(manifest.components)||manifest.components.length>64)return invalid('구성품 수를 확인해 주세요.');
 const conflicts=[],missing_fields=[];
 const observations=(items,fields,scope)=>{
  if(!Array.isArray(items)||items.length>100)return null;
  const values=new Map();
  for(const item of items){
   if(!keys(item,['field','value','unit','source'])||typeof item.field!=='string'||!own(fields,item.field))return null;
   const spec=fields[item.field],source=item.source;
   if(!keys(source,['type','locator','quote'])||typeof source.type!=='string'||!own(contract.source_types,source.type)
    ||!text(source.locator,500,source.type!=='user_statement')||!text(source.quote,2000,true))return null;
   const value=spec.type==='decimal'?decimal(item.value,spec):typeof item.value==='string'&&own(spec.options,item.value)?item.value:null;
   if(value===null||item.unit!==(spec.unit||''))return null;
   if(!values.has(item.field))values.set(item.field,new Set());values.get(item.field).add(value);
  }
  const normalized=Object.create(null);
  for(const [field,choices] of values){
   if(choices.size===1)normalized[field]=[...choices][0];
   else conflicts.push({scope,field,observations:items.filter(o=>o.field===field)});
  }
  return normalized;
 };
 const presentation=observations(manifest.presentation,contract.presentation_fields,'presentation');
 if(!presentation)return invalid('포장·제시 상태의 값과 출처를 확인해 주세요.');
 for(const field of ['one_retail_package','direct_sale','instructions'])if(!own(presentation,field))missing_fields.push({scope:'presentation',field});
 const components=Object.create(null),ids=new Set();let total=0n,allValues=manifest.components.length>0;
 for(const component of manifest.components){
  if(!keys(component,['id','label','observations'])||!text(component.id,64,true)||ids.has(component.id)||component.id==='presentation'||!text(component.label,200,true))return invalid('구성품 식별값·이름을 확인해 주세요.');
  ids.add(component.id);
  const row=observations(component.observations,contract.component_fields,component.id);
  if(!row)return invalid('구성품의 관찰값·단위·출처를 확인해 주세요.');
  components[component.id]=row;
  for(const field of ['kind','role','weight_g','value_share_pct','separate_inner_pack'])if(!own(row,field))missing_fields.push({scope:component.id,field});
  if(row.kind==='pasta'&&!own(row,'preparation'))missing_fields.push({scope:component.id,field:'preparation'});
  if(own(row,'value_share_pct'))total+=scaled(row.value_share_pct);else allValues=false;
 }
 if(total>100000000n||(manifest.inventory_complete&&allValues&&total!==100000000n))conflicts.push({scope:'presentation',field:'value_share_total',message:'포장 전체 가액 비율의 합계를 확인해 주세요.'});
 const status=manifest.paused?'paused':conflicts.length?'conflict':!manifest.confirmed?'confirmation_required':!manifest.inventory_complete||!manifest.components.length||missing_fields.length?'incomplete':'ready_for_comparison';
 return {valid:true,status,final:false,legal_assessment:'not_performed',conflicts,missing_fields,presentation,components};
}
